export default {
  en: require('./en.json'),
  fi: require('./fi.json'),
  sv: require('./sv.json'),
};
